import { useMemo } from "react";

import { useFilterContext } from "../FilterContext";
import { FilterFieldKey } from "../typing";

const useFilterCondition = (): Partial<Record<FilterFieldKey, boolean>> => {
  const { filterOptions } = useFilterContext();
  return useMemo(() => {
    const pointsPriceRange = filterOptions?.pointsPriceRange;
    const distanceRange = filterOptions?.distanceRange;
    const cashRateRange = filterOptions?.cashRateRange;
    const certificates = filterOptions?.certificates;

    return {
      pointsPrice: pointsPriceRange ? pointsPriceRange[1] > 0 : false,
      distance: distanceRange ? pointsPriceRange[1] > 0 : false,
      cashRate: cashRateRange ? pointsPriceRange[1] > 0 : false,
      certificates: certificates ? certificates.length > 1 : false,
    };
  }, [filterOptions]);
};

export default useFilterCondition;
